import { Grid } from "@mui/material";
import { useEffect, useMemo } from "react";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";

export const Curriculum = ({
    allowedWrite,
    isNew,
    datosSeleccionFormData,
    handleChange,
    handlePreview,
    handleChangeArchivo,
    handleDelete
}) => {

    useEffect(() => {
        handleChange('curriculumCheck', datosSeleccionFormData?.curriculum?.length > 0);
    }, [datosSeleccionFormData?.curriculum]);

    const updatedFields = useMemo(() => {
        return (structuredClone(fields)
            .map(input => {
                const updatedInput = { ...input };
                if (!allowedWrite) {
                    updatedInput.disabled = true;
                }
                return updatedInput;
            }))
    }, [isNew, allowedWrite]);

    return (
        <div className='generic-tab-container container-separate'>
            <Grid container spacing={2}>
                {updatedFields
                    .map((input, index) => (
                        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
                            {
                                !!input.title
                                    ?
                                    <div className='generic-header-tab-content-with-buttons'>
                                        <strong>{input.title}</strong>
                                    </div>
                                    :
                                    !!input.subtitle
                                        ?
                                        <strong>{input.subtitle}</strong>
                                        :
                                        <RenderInputByTypeMobile
                                            key={`input-${input.name}-index-${index}`}
                                            input={input}
                                            handleChange={input.type === 'file' ? handleChangeArchivo : handleChange}
                                            handleDelete={input.type === 'file' ? handleDelete : null}
                                            value={datosSeleccionFormData[input.name]}
                                        />
                            }
                        </Grid>
                    ))
                }
            </Grid>
        </div>
    );
}

const fields = [
    {
        title: 'Currículum Vitae',
        name: 'curriculumVitae',
        col: 12,
    },
    {
        displayName: 'Currículum',
        name: 'curriculumCheck',
        type: 'custom_switch',
        disabled: true,
        col: 4
    },
    {
        displayName: 'Adjuntar Curriculum',
        name: 'curriculum',
        type: 'file',
        validExtensions: ['PNG', 'PDF', 'JPG'],
        col: 6
    },
    {
        name: 'item',
        type: 'item',
        col: 5
    },
];